module.exports = __webpack_public_path__ + "static/media/Engxg6.9cc2d289.png";